import React from 'react'
import type { MusicContextType } from '@tunasong/music-lib'

export const MusicContext = React.createContext<MusicContextType | null>(null)
